<template>
  <div class="clm__product">
    <a :href="`/products/${product.handle}?color=${productForm.Color}`" target="_blank">
      <h4 class="clm__product-title">
        {{product.title}}
      </h4>
    </a>
    <ProductPrice
      :product="product"
      :selectedFirstOption="renderFirstOptions[productForm[firstOption]]"
    />
    <span class="clm__product-desc">{{product.description}}</span>

    <!-- Product Options -->
    <ProductOptions
      :product="product"
      :renderFirstOptions="renderFirstOptions"
      :productForm="productForm"
      :isSecondTurn="false"
      @on-option-change="onOptionChange"
    />

    <!-- Size Guide Btn -->
    <div v-if="sizeGuideVal" class="clm__size-guide" @click="toggleSizeDrawer">Size Guide</div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, reactive, onMounted } from 'vue';
  import ProductPrice from '../pdp-first-fold/components/product-price.vue';
  import ProductOptions from '../pdp-first-fold/components/product-options.vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    productForm: {
      type: Object,
      required: true,
    }
  })

  const { product,productForm } = toRefs(props)
  var firstOption = reactive(product.value.options[0].name)
  var sizeGuideVal = ref(null)

  onMounted(async() => {
    const _sizeGuide = await(await fetch(`https://www.stio.com/products/${product.value.handle}?view=size-guide`)).json()
    sizeGuideVal.value = _sizeGuide
  })

  const renderFirstOptions = computed(() => {
    const {variants,tags,images,available} = product.value;

    const firstLevelOptions = variants.reduce((set, variant) => {
      const property = variant.option1;
      const setItem = set[property] = set[property] || { items: [] }
      setItem.items.push(variant)
      if(variant.available) setItem.items.available = true
      return set
    }, {});

    Object.entries(firstLevelOptions).forEach(([key, value]) =>{
      const isAvailable = value.items.available;
      const bisData = tags.filter(tag => tag.toLowerCase().includes(`bis: ${key.toLowerCase()}`))
      
      value.image = images.filter(image => {
        const alt = image.alt.toLowerCase()
        return alt.includes(key.toLowerCase()) && alt.includes('swatch')
      })[0].src
      value.price = Number(value.items[0].price/100)
      value.compare_at_price = Number(value.items[0].compare_at_price/100)

      if(bisData.length){
        value.bis = true;
        value.bisDate = bisData[0].split('[')[1].replace(']','');
      }
    });

    return firstLevelOptions;
  })

  const onOptionChange = (key,value,index,length) => {
    productForm.value[key] = value;
    updateVariantValue();
  }

  const updateVariantValue = () => {
    let variantValue = ''
    const {options} = product.value;
    options.forEach((option,index,array) => {
      variantValue +=  productForm.value[option.name];
      if (index != (array.length -1)) (variantValue += ' / ')
    })

    updateSelectedVariant(variantValue)
  }

  const updateSelectedVariant = (value) => {
    const variant = renderFirstOptions.value[productForm.value[firstOption]].items.filter(variant => variant.value === value)[0]
    if(variant) productForm.value.selectedVariant = variant;
    else productForm.value.selectedVariant = null;
  }

  const toggleSizeDrawer = () => {
    window.toggleDrawer(true,'SizeGuide',
      {
        'sizeguide':sizeGuideVal.value
      }
    )
  }
</script>